// faqActions.ts

import {
  addfaqcategory,
  updatefaqcategory,
  listfaqcategoryadmin,
  addfaqquestion,
  updatefaqquestion,
  deletefaqquestion,
  listfaqquestionadmin,
} from "services/faqService"; 

import {
  fetchFaqData,
  fetchSingleFaqData,
  fetchFaqCategories,
  setPagination,
  setFaqLoader,
  faqSuccessMsg,
  faqErrorMsg,
} from "./reducer";

export const fetchFaqList = (params?: any) => async (dispatch: any) => {
  dispatch(setFaqLoader(true));

  try {
    const payload = {
      page: params?.page ?? 1,
      page_size: params?.page_size ?? 10,
      category_id: params?.category_id ?? 0,
      status: params?.status ?? "",
      search: params?.search ?? "",
    };

    const response = await listfaqquestionadmin(payload);

    if (response?.success) {
      dispatch(fetchFaqData(response)); 
      const pagination = response?.data?.pagination || {};
      dispatch(setPagination(pagination));
    } else {
      dispatch(
        faqErrorMsg({
          message: response?.message || "Failed to fetch FAQ list",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      faqErrorMsg({
        message: error?.message || "Error while fetching FAQs",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setFaqLoader(false));
  }
};


export const addFaqQuestion = (faqData: any) => async (dispatch: any) => {
  dispatch(setFaqLoader(true));

  try {
    const response = await addfaqquestion(faqData);

    if (response?.success) {
      dispatch(
        faqSuccessMsg({
          message: response?.message || "FAQ Question added successfully",
          id: Date.now(),
        })
      );
      dispatch(fetchFaqList({}));
    } else {
      dispatch(
        faqErrorMsg({
          message: response?.message || "Failed to add FAQ question", 
          id: Date.now(),
        })
      );
    }
    return response; // IMPORTANT
  } catch (error: any) {
    dispatch(
      faqErrorMsg({
        message: error?.response?.data?.message || "Something went wrong while adding FAQ",
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: error?.response?.data?.message || error?.message,
    };
  } finally {
    dispatch(setFaqLoader(false));
  }
};

export const updateFaqQuestion =
  (question_id: number, faqData: any) => async (dispatch: any) => {
    dispatch(setFaqLoader(true));

    try {
      const response = await updatefaqquestion(question_id, faqData);

      if (response?.success) {
        dispatch(
          faqSuccessMsg({
            message: response?.message || "FAQ updated successfully",
            id: Date.now(),
          })
        );
        dispatch(fetchFaqList());
      } else {
        dispatch(
          faqErrorMsg({
            message: response?.message || "Failed to update FAQ",
            id: Date.now(),
          })
        );
      }
      return response; 
    } catch (error: any) {
      dispatch(
        faqErrorMsg({
          message: error?.message || "Error while updating FAQ",
          id: Date.now(),
        })
      );
      return { success: false, message: error?.message }; 
    } finally {
      dispatch(setFaqLoader(false));
    }
  };

export const deleteFaqQuestion = (question_id: number) => async (dispatch: any) => {
  dispatch(setFaqLoader(true));

  try {
    const response = await deletefaqquestion(question_id);

    if (response?.success) {
      dispatch(
        faqSuccessMsg({
          message: response?.message || "FAQ deleted successfully",
          id: Date.now(),
        })
      );
      dispatch(fetchFaqList());  
    } else {
      dispatch(
        faqErrorMsg({
          message: response?.message || "Failed to delete FAQ",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      faqErrorMsg({
        message: error?.message || "Error while deleting FAQ",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setFaqLoader(false));
  }
};

export const fetchFaqCategoryAdmin = () => async (dispatch: any) => {
  try {
    const res = await listfaqcategoryadmin();

    if (res?.success && res?.data) {
      const arr = Array.isArray(res.data) ? res.data : [res.data];
      dispatch(fetchFaqCategories(arr));
    }
  } catch (error) {
    dispatch(faqErrorMsg({ message: "Failed to load FAQ categories", id: Date.now() }));
  }
};

export const addFaqCategory = (data: any) => async (dispatch: any) => {
  dispatch(setFaqLoader(true));

  try {
    const res = await addfaqcategory(data);

    if (res?.success) {
      dispatch(
        faqSuccessMsg({
          message: res?.message || "Category added successfully!",
          id: Date.now(),
        })
      );
      dispatch(fetchFaqCategoryAdmin()); 
    } else {
      dispatch(
        faqErrorMsg({
          message: res?.message || "Failed to add category",
          id: Date.now(),
        })
      );
    }
    return res;
  } catch (error: any) {
    dispatch(
      faqErrorMsg({
        message: error?.message || "Error while adding category",
        id: Date.now(),
      })
    );
    return { success: false, message: error?.message }; 
  } finally {
    dispatch(setFaqLoader(false));
  }
};

export const updateFaqCategory =
  (category_id: number, data: any) => async (dispatch: any) => {
    dispatch(setFaqLoader(true));

    try {
      const res = await updatefaqcategory(category_id, data);

      if (res?.success) {
        dispatch(
          faqSuccessMsg({
            message: res?.message || "FAQ Category updated successfully",
            id: Date.now(),
          })
        );
        dispatch(fetchFaqCategoryAdmin());  
      } else {
        dispatch(
          faqErrorMsg({
            message: res?.message || "Failed to update FAQ Category",
            id: Date.now(),
          })
        );
      }
      return res; 
    } catch (error: any) {
      dispatch(
        faqErrorMsg({
          message: error?.message || "Error updating FAQ Category",
          id: Date.now(),
        })
      );
      return { success: false, message: error?.message }; 
    } finally {
      dispatch(setFaqLoader(false));
    }
  };

